import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import dayjs from 'dayjs';

import { SparkLineChart } from '@mui/x-charts/SparkLineChart';

function getDaysInMonth(month, year) {
  const date = new Date(year, month, 0);
  const monthName = date.toLocaleDateString('en-US', {
    month: 'short',
  });
  const daysInMonth = date.getDate();
  const days = [];
  let i = 1;
  while (days.length < daysInMonth) {
    days.push(`${monthName} ${i}`);
    i += 1;
  }
  return days;
}

function renderSparklineCell(params) {
  const data = getDaysInMonth(10, 2024);
  const { value, colDef } = params;

  if (!value || value.length === 0) {
    return null;
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <SparkLineChart
        data={value}
        width={colDef.computedWidth || 100}
        height={32}
        plotType="bar"
        showHighlight
        showTooltip
        colors={['hsl(210, 98%, 42%)']}
        xAxis={{
          scaleType: 'band',
          data,
        }}
      />
    </div>
  );
}

function renderStatus(status) {
  const colors = {
    Online: 'success',
    Offline: 'default',
  };

  return <Chip label={status} color={colors[status]} size="small" />;
}

export function renderAvatar(params) {
  if (params.value == null) {
    return '';
  }

  return (
    <Avatar
      sx={{
        backgroundColor: params.value.color,
        width: '24px',
        height: '24px',
        fontSize: '0.85rem',
      }}
    >
      {params.value.name.toUpperCase().substring(0, 1)}
    </Avatar>
  );
}

export const columns = [
  { field: 'fleet_name', headerName: 'Fleet', flex: 1.5, minWidth: 200 },
  {
    field: 'vehicle_count',
    headerName: 'Vehicles',
    headerAlign: 'right',
    align: 'right',
    flex: 1,
    minWidth: 80,
  },
  {
    field: 'battery_pack_count',
    headerName: 'Battery Packs',
    headerAlign: 'right',
    align: 'right',
    flex: 1,
    minWidth: 100,
  },
  {
    field: 'fleet_owner',
    headerName: 'Assigned to',
    headerAlign: 'right',
    align: 'right',
    flex: 1,
    minWidth: 120,
  },
  {
    field: 'createdAt',
    headerName: 'Created at',
    headerAlign: 'right',
    align: 'right',
    flex: 1,
    minWidth: 100,
    valueFormatter: (params) => { // Ensure params.value is a valid date
      if (params) {
        return dayjs(params).format('DD-MM-YY hh:mm A');
      } return '';
    }
  },
];

export const rows = [
  {
    id: 1,
    fleetName: "MSR",
    status: 'Online',
    vehicles: '40/125',
    packs: '80/250',
    assignedTo: 'IGT',
    createdAt: '0',
    packetHistory: [
      469172, 488506, 592287, 617401, 640374, 632751, 668638, 807246, 749198, 944863,
      911787, 844815, 992022, 1143838, 1446926, 1267886, 1362511, 1348746, 1560533,
      1670690, 1695142, 1916613, 1823306, 1683646, 2025965, 2529989, 3263473,
      3296541, 3041524, 2599497,
    ]
  },
  {
    id: 2,
    fleetName: "MSR #2",
    status: 'Offline',
    vehicles: '0/125',
    packs: '0/125',
    assignedTo: 'IGT',
    createdAt: '0',
    packetHistory: Array(30).fill(0)
  },
  {
    id: 3,
    fleetName: "C3",
    status: 'Offline',
    vehicles: '0/125',
    packs: '0/125',
    assignedTo: 'IGT',
    createdAt: '0',
    packetHistory: Array(30).fill(0)
  },
  {
    id: 4,
    fleetName: "C3 #2",
    status: 'Offline',
    vehicles: '0/125',
    packs: '0/125',
    assignedTo: 'IGT',
    createdAt: '0',
    packetHistory: Array(30).fill(0)
  },
  {
    id: 5,
    fleetName: "Kangaroo",
    status: 'Offline',
    vehicles: '0/100',
    packs: '0/100',
    assignedTo: 'IGT',
    createdAt: '0',
    packetHistory: Array(30).fill(0)
  },
];
